// import { Store } from "vuex";

const mutations = {
  CART (store, data) {
    store.cart = data
  },
  CARTPRODUCTS (store, data) {
    store.cartProducts = data
  },
  ERRORS (store, data) {
    store.errors = data
  },
  ADDONS (store, data) {
    store.addons = data
  },
  COMMENT (store, data) {
    store.comment = data
  },
  CANTIDAD (store, data) {
    store.cantidad = data
  },
  PERMITEDSUBMIT (store, data) {
    store.permitedSubmit = data
  },
  CART_TEMPORAL (store, data) {
    store.cartTemporal = data
  },
  DONATION_PRODUCTS (store, data) {
    store.donationProducts = data
  },
  OPEN_CART (store, data) {
    store.openCart = data
  },
  OPEN_CATEGORIES (store, data) {
    store.openCategories = data;
  },
  OPEN_SEARCH_BAR (store, data) {
    store.openSearchBar = data;
  },
  CART_COMMERCE_ID (store, data) {
    store.cartCommerceId = data 
  },
  OPEN_COUPON_MODAL (store, data) {
    store.openCouponModal = data
  },
  OPEN_PROMO_EXCEEDED_MODAL (store, data) {
    store.openPromoExceededModal = data
  },
  LAST_PROMO_EXCEEDED_PRODUCT (store, data) {
    store.lastPromoExceededProduct = data;
  },
  FREE_PRODUCTS (store, data) {
    store.freeProducts = data;
  },
  USER_VALID_COUPONS (store, data) {
    store.userValidCoupons = data;
  },
  ORDERS_WITH_COUPONS (store, data) {
    store.ordersWithCoupons = data;
  },
  CART_DELETED_PRODUCTS (store, data) {
    store.cartDeledProducts = data;
  }
}

export default mutations
